import { useCallback } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { BackSVG, Button } from "./styles";

const BackButton = ({
  customCallback,
  customBackButtonPath,
}: {
  customCallback?: () => void;
  customBackButtonPath?: string | null;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, , removeCookie] = useCookies();
  const { t } = useTranslation();

  const deepLinkCallback = useCallback(() => {
    removeCookie("STATE", { path: "/" });
    removeCookie("OFFER", { path: "/subscriptionplus" });
    navigate("/");
  }, [navigate, removeCookie]);

  return (
    <Button
      data-testid="back-button"
      aria-label={t("go back")}
      onClick={() =>
        customCallback
          ? customCallback()
          : customBackButtonPath
          ? navigate(customBackButtonPath)
          : location.state?.initial_deeplink
          ? deepLinkCallback()
          : navigate(-1)
      }
    >
      <BackSVG
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M11 3.5L2.5 12L11 20.5" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 12H21.5" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
      </BackSVG>
    </Button>
  );
};

export default BackButton;
